import { Button } from "@mui/material"
import { useState } from "react"
import { useNotify, useRecordContext, useRedirect, useTranslate } from "react-admin"
import SendEmailDialog from "../../emails/actionDialogs/SendEmailDialog"
import { useMutation } from "react-query";
import { InvoiceReadModel, SendInvoiceByMailCommand, UserReadModel } from "../../GeneratedClients/FreeBillApi";
import { apiService } from "../../apiService";
import { defaultTextInvoice } from "../../emails/actionDialogs/getDefaultText";
import validateEmail from "../../emails/validateEmail";
import MailValidationFailedDialog from "../../emails/actionDialogs/MailValidationFailedDialog";

const SendInvoiceButton = ({user}: {user?: UserReadModel}) => {

  const translate = useTranslate()
  const notify = useNotify()
  const redirect = useRedirect()
  const invoice = useRecordContext<InvoiceReadModel>()
  const [open, setOpen] = useState<boolean>(false)
  const { mutate, isLoading } = useMutation((command: SendInvoiceByMailCommand) => 
    apiService.InvoicesApi.send({sendInvoiceByMailCommand: command, id: command.id!}),
    {
      onSuccess: (data) => {
        notify(translate("resources.invoices.notifications.sent"))
        redirect('list', "invoices")
      },
      onError: (error: any) => {
        notify(error, {type: error})
      }
    }   
  )

  const handleOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  const record: SendInvoiceByMailCommand = {
    id: invoice.id, 
    fromAddress: user?.mailServiceConfig?.email,
    fromName: user?.mailServiceConfig?.sender,
    toAddresses: invoice.invoiceRecipient?.company?.email ? [invoice.invoiceRecipient?.company?.email] : undefined,
    toName: invoice.invoiceRecipient?.company?.companyName,
    subject: invoice.textModel?.heading,
    emailText: defaultTextInvoice(user), 
    userId: invoice.userId
  }

  const handleSubmit = (command: SendInvoiceByMailCommand) => {
    mutate(command)
  }

  const emailValidation = validateEmail(user?.mailServiceConfig)

  if(!invoice) return null
  
  return (
    <>
      <Button 
        onClick={handleOpen} 
        size="small"
      >
        {translate('resources.invoices.actions.send')}
      </Button>
      {
        !emailValidation.isValid ? (
          <MailValidationFailedDialog 
            message={emailValidation.message} 
            actionButtonText={emailValidation.actionButtonText} 
            open={open}
            handleClose={handleClose}
          />
        ) : (
          <SendEmailDialog 
            record={record} 
            handleSubmit={handleSubmit} 
            attachments={[
              {
                attachmentFileName: `${invoice.textModel?.heading}.pdf`,
                id: invoice.id,
                resource: "invoices"
              }
            ]}
            isLoading={isLoading} 
            resource='invoices'
            dialogText={translate("resources.invoices.dialogs.send")}
            open={open}
            handleClose={handleClose}  
          />
        )
      }
    </>
  )
}

export default SendInvoiceButton